import { downloadFile } from '@delmonicos/shared-sdk/libs/core/src/helpers/download-file';
import { getFilenameFromContentDisposition } from '@delmonicos/shared-sdk/libs/core/src/helpers/get-filename-from-response';
import { GatewayGetTransactionsExportModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-export.model';

export const getExportFilename = (
  requestParameters: GatewayGetTransactionsExportModel,
  response: Response,
): string => {
  return (
    getFilenameFromContentDisposition(response) ??
    `export-${requestParameters.createdAfter}-${requestParameters.createdBefore}.csv`
  );
};

export const downloadExport = async (
  requestParameters: GatewayGetTransactionsExportModel,
  response: Response,
): Promise<void> => {
  await downloadFile(response, getExportFilename(requestParameters, response));
};
